import React, {Component} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import {inject} from 'mobx-react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import customBaseTheme from 'modules/theme/customBaseTheme';

import {containers as BaseContainers} from '../modules/core';
import {containers as ProfileContainer} from '../modules/profile';

import {containers as TopicContainer} from '../modules/topic';

import NotFound from 'modules/blocks/404';

import AboutUs from 'modules/informations/AboutUs';
import ContactUs from 'modules/informations/ContactUs';

import TermsOfService from 'modules/informations/TermsOfService';
import PrivacyPolicy from 'modules/informations/PrivacyPolicy';
import CookiesPolicy from 'modules/informations/CookiesPolicy';

import {containers as ResourcesContainer} from '../modules/resources';
import {containers as ExamPrepDashboardContainer} from 'modules/examPrepDashboard';

import {containers as MCQThemesContainer} from 'modules/admin/mcqThemes';
import {containers as McqQuestionsContainer} from 'modules/admin/mcqQuestions';

import {containers as MCQSection} from 'modules/mcq';

import {containers as SampleContentContainer} from '../modules/admin/sampleContent';

const {
  Header,
  ExamPrepHeader,
  Sidebar,
  Footer
} = BaseContainers;

const {
  Profile,
  Logout
} = ProfileContainer;

const {
  Topic,
  TopicOnlyQuiz,
  TopicsList,
  ExamPrepTopic
} = TopicContainer;

const {ExamPrepDashboard} = ExamPrepDashboardContainer;

const {
  AddResource,
  Resources,
  EditResource
} = ResourcesContainer;

const {
  McqThemes,
  AddMcqTheme,
  EditMcqTheme,
} = MCQThemesContainer;

const {
  McqQuestions,
  AddQuestion,
  EditQuestion,
} = McqQuestionsContainer;

const {
  McqMainSection,
  ActiveSession,
  PerformanceDetails,
} = MCQSection;

const {
  AddSampleContent,
  EditSampleContent,
  SampleContentList,
} = SampleContentContainer;

@inject('userStore')
export default class extends Component {
  render() {
    const {userStore} = this.props;
    const isAdmin = userStore.isAdmin();

    return (
      <MuiThemeProvider muiTheme={getMuiTheme(customBaseTheme)} key={3}>
        <div className="public-wrap main-wrap">
          {isAdmin ? (
            <Header />
          ) : (
            <ExamPrepHeader />
          )}
          <Switch>
            <Route path="/settings" component={Profile} />
            <Route path="/dashboard" component={TopicsList} />
            <Route path="/logout" component={Logout} />
            <Route path="/notfound" component={NotFound} />

            <Route path="/about-us" component={AboutUs} />
            <Route path="/contact-us" component={ContactUs} />
            <Route path="/terms-of-service" component={TermsOfService} />
            <Route path="/privacy-policy" component={PrivacyPolicy} />
            <Route path="/cookies-policy" component={CookiesPolicy} />

            <Route path="/" exact component={isAdmin ? TopicsList : ExamPrepDashboard} />

            <Route path="/topics" component={TopicsList} exact />
            <Route path="/topic" component={Topic} exact />
            <Route path="/topic/:id" component={Topic} />

            <Route path="/exam-prep/:id/topics" component={TopicsList} />
            <Route path="/exam-prep/topic" component={Topic} exact />
            <Route path="/exam-prep/topic/:id" component={ExamPrepTopic} />
            <Route path="/exam-prep/:id/resources" component={Resources} />
            <Route path="/exam-prep/:id/mcqs" component={TopicOnlyQuiz} />

            <Route path="/resources" component={Resources} exact />

            <Route path="/exam-prep/:id/mcq" component={McqMainSection} exact />
            <Route path="/exam-prep/:id/mcq/:sessionId" component={ActiveSession} exact />
            <Route path="/exam-prep/:id/mcq/performance/:sessionId" component={PerformanceDetails} exact />

            {isAdmin && [
              <Route key={`admin_res_add`} path="/resources/add" component={AddResource} exact />,
              <Route key={`admin_res_edit`} path="/resources/:id/edit" component={EditResource} />,

              <Route key={`admin_themes`} path="/mcq-themes/" component={McqThemes} exact />,
              <Route key={`admin_themes_add`} path="/mcq-themes/add" component={AddMcqTheme} exact />,
              <Route key={`admin_themes_edit`} path="/mcq-themes/:id/edit" component={EditMcqTheme} />,

              <Route key={`admin_questions`} path="/mcq-questions" component={McqQuestions} exact />,
              <Route key={`admin_questions_add`} path="/mcq-questions/add" component={AddQuestion} exact />,
              <Route key={`admin_questions_edit`} path="/mcq-questions/:id/edit" component={EditQuestion} />,

              <Route key={`admin_sample_content_add`} path="/sample-content/add" component={AddSampleContent} exact />,
              <Route key={`admin_sample_content_edit`} path="/sample-content/:id/edit" component={EditSampleContent} />,
              <Route key={`admin_sample_content_list`} path="/sample-content" component={SampleContentList} exact />,
            ]}

            <Redirect to="/notfound" />
          </Switch>
          <Sidebar/>
          <Footer/>
        </div>
      </MuiThemeProvider>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/private.js